var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat__answer"},[_c('span',[_vm._v(_vm._s(_vm.username))]),_c('p',[_vm._v(_vm._s(_vm.text))]),(_vm.closeable)?_c('div',{staticClass:"chat__answer__close"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }